// extracted by mini-css-extract-plugin
export default {"cell":"Cell_cell__hdDyU","stacked":"Cell_stacked__ADB-x","small":"Cell_small__e-lqu"};